import React, { useContext, useState } from 'react'
import { default as LoginTemplateSipec } from '../../components/template/LoginTemplate/LoginTemplate'
import { api, JWT_GET_TOKEN_ENDPOINT } from '../../utils'
import { AuthContext } from '../../context/AuthContext'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import LoadingSvg from '../../components/atoms/Loading/Loading'
import { isSocialLoginAllowed } from '../../utils/servicegift'
import { GoogleOAuthProvider } from '@react-oauth/google'
import LoginTemplateSg from '../../components/template/LoginTemplateSg/LoginTemplateSg'
import { trackingGAEvent } from '../../utils/gtm'

const AccediPage = ({ page }) => {
  const { isAuth, setAuth } = useContext(AuthContext)
  const [error, setError] = useState()
  const router = useRouter()
  const service_gift = useSelector((state) => state.servicegift?.service_gift)
  const { utente, fetching, fetched } = useSelector((state) => state.utente)

  const LoginTemplate = service_gift ? LoginTemplateSg : LoginTemplateSipec

  const Wrapper = ({ children }) =>
    isSocialLoginAllowed(service_gift) ? (
      <GoogleOAuthProvider clientId={service_gift.social_auth_google_oauth2_key}>
        {children}
      </GoogleOAuthProvider>
    ) : (
      <>{children}</>
    )

  const Login = async (params) => {
    const user_input = { username: params.email, password: params.password }

    await api
      .post(`${JWT_GET_TOKEN_ENDPOINT}`, user_input)
      .then((res) => {
        setAuth(true)
        window.location.href = router.query?.next || '/'
        setError()
        trackingGAEvent('login')
      })
      .catch((err) => {
        setError(err.message)
      })
  }

  if (fetching) {
    return <LoadingSvg />
  }

  if (fetched && utente?.id) {
    router.replace(`/myaccount`)
    return <LoadingSvg />
  }

  return (
    <Wrapper>
      <LoginTemplate Login={Login} CredentialError={error} />
    </Wrapper>
  )
}

export default AccediPage

export const Logout = async (redirect_url) => {
  await api.get('/me/logout').catch((err) => console.log(err))

  process.browser &&
    window !== undefined &&
    ((window.location.href = redirect_url ? redirect_url : '/'), window.location.reload())
}
